<template lang="pug">
  .b2b-page-createcover
    ods-module
      div(slot='header')
        ods-row.info(type='flex', align='middle')
          ods-col(:span='8')
            div {{ $t('pendingtask.createcover.cover.titleaux') }}
      ods-form(
        label-width='14rem',
        label-position='left',
        size='mini')
        ods-row(type='flex')
          ods-col(:span='24')
            ods-radio(
              v-model='radio',
              label='1')
              | {{ $t('pendingtask.createcover.rbInvoice') }}
            ods-radio.separate(
              v-model='radio',
              label='2')
              | {{ $t('pendingtask.createcover.rbPaymentProposal') }}
    ods-row.form-actions()
      ods-col(:span='1')
        ods-button.buttonleft(
          :disabled="(!this.radio)"
          type='primary',
          @click='createCoverInvoice')
          | {{ $t('pendingtask.createcover.cover.btnCover') }}
      ods-col(:span='23')
        ods-button(
          :disabled="(!this.radio)"
          v-if="btnNextVisible",
          type='primary',
          @click='goSendCover')
          | {{ $t('buttons.btnNext') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Utils from '@/components/shared/Utils'

export default {
  name: 'b2b-page-createcover',
  mixins: [Utils],
  data () {
    return {
      radio: null,
      btnNextVisible: false,
      action: 'CREATE'
    }
  },

  computed: {
    ...mapGetters([
      'invoiceNoteIdsPendingTask',
      'hasCoverPendingTask',
      'radioOption'
    ])
  },

  methods: {
    ...mapActions([
      'createCover',
      'hasCoverPendingTaskState',
      'radioOptionState'
    ]),

    goSendCover () {
      if (this.hasCoverPendingTask) {
        this.$emit('update', 1)
      }
    },

    // Crear caratula si la factura no existe la crea,si existe y mle damos de nuevo a crear caratula la reinicia
    async createCoverInvoice () {
      this.btnNextVisible = false

      const load = this.$loading({
        lock: true,
        text: this.$t('pendingtask.createcover.cover.create')
      })

      try {
        const params = {
          actionType: this.action,
          invoiceAttachmentCategoryId: this.radio,
          invoiceNoteId: this.invoiceNoteIdsPendingTask
        }

        await this.radioOptionState(this.radio)
        console.log('radioOptionState: ', this.radioOption)
        await this.createCover(params)
        // Carátula creada
        await this.hasCoverPendingTaskState(true)

        this.$notify({
          title: this.$t('pendingtask.createcover.cover.create_ok'),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })

        // Redirigimos a envío de caratula
        this.$emit('update', 1)
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    async getNotificationErrorMessage (error) {
      console.log(error)
      const statusCode = error.status
      let errorSms = ''
      let type = 'error'
      switch (statusCode) {
        case 400:
          errorSms = error.data.message
          break
        case 401:
          errorSms = this.$i18n.messages.es.error.e401
          break
        case 403:
          errorSms = this.$i18n.messages.es.error.e403
          break
        case 404:
          errorSms = error.data.message
          break
        case 409:
          type = 'warning'
          this.btnNextVisible = true
          this.action = 'RESTART'
          await this.hasCoverPendingTaskState(true)
          errorSms = error.data.message
          break
        case 500:
          errorSms = error.data.message
          break
        default:
          errorSms = this.$i18n.messages.es.error.default
          break
      }
      error.data.message = errorSms
      this.showNotificationError(error, 10000, type)
    }
  },

  async created () {
    console.log('radio: ', this.radio)
  }
}
</script>

<style lang="scss" scoped>
.b2b-page-createcover {
  padding: 40px 40px 40px 40px;

  ::v-deep .ods-module{
    &__header{
      background-color: var(--color-bg-hover-2);
      padding: 0px;
      .info{
        margin-left: 40px;
        margin-right: 40px;
        height: 72px;
        color: var(--color-bg-interactive);
        size: 16px;
        line-height: 24px;
      }
    }

    &__body{
      padding: 32px;
      .info{
        padding-bottom: 32px;
      }
    }
  }

  .form-actions{
    padding-top: 40px;
    padding-bottom: 40px;
    .ods-button{
      float: right;
      margin-left: 20px;
    }
    .ods-button.buttonleft{
      float: left;
      margin-left: 0px;
    }
  }

  .collapse{
    margin-top: 64px;
    .info {
      margin-left: 1rem;
      color: var(--color-txt-secondary);
    }

    .ods-button{
      float: right;
    }

    ::v-deep .ods-module{
      &__body{
        padding: 0px;
      }
    }
  }
    ::v-deep .separate {
    margin-left: 10%;
  }

}
</style>
